// extracted by mini-css-extract-plugin
module.exports = {"centerDiv":"search_centerDiv__27vYr","searchBox":"search_searchBox__36hFl","loader-box":"search_loader-box__XyL4Q"};